<template>
  <div class="html-editor">
    <v-layout row wrap>
      <v-flex>
        <v-label>{{ schema.$schema.title }}</v-label>
      </v-flex>

      <v-flex shrink v-if="codeEditor">
        <v-switch v-model="showCodeEditor" label="Kod źródłowy" class="html-switch" />
      </v-flex>
    </v-layout>

    <v-layout v-if="showCodeEditor" row wrap>
      <v-flex sm6 xs12>
        <v-label>Kod źródłowy</v-label>

        <code-editor lang="html" :model="schema" />
      </v-flex>

      <v-spacer />

      <v-flex sm6 hidden-sm-and-down pl-1>
        <v-label>Podgląd</v-label>

        <div v-html="schema.$value" />
      </v-flex>
    </v-layout>

    <w-wysiwyg v-else :model="schema" :options="options" />
  </div>
</template>

<script>
import { schemaMixin } from '@witkac/vuetify-components';
import WWysiwyg from '@witkac/vuetify-components/src/components/wysiwyg.vue';

import CodeEditor from './CodeEditor';

// @vuese
// Edytor WYSIWYG
// @group Components/Forms
export default {
  components: { CodeEditor, WWysiwyg },
  mixins: [schemaMixin],
  props: {
    // Schema przekazana do komponentu
    schema: {
      type: Object,
      required: true
    },
    // Czy włączyć edytor kodu źródłowego
    codeEditor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCodeEditor: false,
      options: {
        hideModules: {
          code: true,
          headings: true,
          link: true,
          table: true
        }
      }
    };
  }
};
</script>

<style>
.editr--toolbar input {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  line-height: 20px;
  padding: 8px 0;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}
.html-switch {
  padding-top: 0;
  margin-top: 0;
}
.html-switch .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
